import React from 'react';
const tomes = [{
  label: 'Tomo 1',
  color: 'rgb(21, 50, 120)',
  emoji: '💰',
  desc: 'Ingeniería del Dojo'
}, {
  label: 'Tomo 2',
  color: 'rgb(139, 0, 0)',
  emoji: '🎯',
  desc: 'Pedagogía de Retención'
}, {
  label: 'Tomo 3',
  color: 'rgb(20, 83, 45)',
  emoji: '📣',
  desc: 'Marketing Guerrero'
}, {
  label: 'Tomo 4',
  color: 'rgb(120, 53, 15)',
  emoji: '🥋',
  desc: 'Programas de Grados Pro'
}, {
  label: 'Tomo 5',
  color: 'rgb(88, 28, 135)',
  emoji: '🤝',
  desc: 'Psicología del Cierre'
}, {
  label: 'Tomo 6',
  color: 'rgb(15, 70, 60)',
  emoji: '👑',
  desc: 'Liderazgo y Staff'
}];
const features = ['✅ +600 páginas de sistema completo', '✅ Gestión, retención y marketing', '✅ Planificación técnica de 48 semanas', '✅ Para instructores de cualquier disciplina', '✅ Scripts, contratos y planillas listas', '✅ Descargalo hoy, implementalo mañana'];
export function ProductShowcase() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: 'rgb(12, 12, 22)',
    backgroundImage: 'linear-gradient(180deg, rgb(12, 8, 10) 0%, rgb(10, 10, 10) 50%, rgb(14, 8, 10) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-234">
      <div className="mx-auto max-w-4xl text-center" data-id="element-235">
        {/* BADGE */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-red-500 border border-red-900 bg-red-950/50 rounded-full px-4 py-1.5" data-id="element-236">
          🏆 El sistema más completo para instructores de Argentina
        </div>

        {/* MARCA */}
        <h2 className="font-black text-white m-0 mb-2 text-[20px]" data-id="element-237">
          🥋 CONSTRUYE PROGRESO™
        </h2>

        {/* NOMBRE DEL PRODUCTO */}
        <h3 className="text-xl font-bold text-red-500 m-0 mb-4" data-id="element-238">
          MEGAPACK ARTES MARCIALES
        </h3>

        {/* DESCRIPCIÓN */}
        <p className="mx-auto max-w-2xl text-base leading-[24px] text-gray-300 m-0 mb-8" data-id="element-239">
          <strong className="text-white" data-id="element-240">
            6 Tomos + 6 Bonos — Para instructores de cualquier disciplina — Todo
            listo para implementar.
          </strong>
          <br data-id="element-241" />
          +600 páginas · Gestión Financiera · Retención de Alumnos · Marketing
          Orgánico · Planificación Técnica Anual · Psicología de Ventas ·
          Liderazgo · Scripts · Contratos · Sin improvisación. Descargalo hoy y
          usalo mañana.
        </p>

        {/* TOMOS GRID */}
        <div className="relative mx-auto max-w-3xl mb-8" data-id="element-242">
          <div className="grid grid-cols-6 justify-center gap-2" data-id="element-243">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center justify-between aspect-[3/4] shadow-md border-2 border-red-900 rounded-lg overflow-hidden" style={{
            backgroundColor: tome.color
          }} data-id="element-244">
                <div className="flex-1 flex items-center justify-center" data-id="element-245">
                  <span className="text-3xl sm:text-4xl drop-shadow-lg" data-id="element-246">
                    {tome.emoji}
                  </span>
                </div>
                <div className="w-full bg-black/40 backdrop-blur-sm py-1.5 px-1 text-center" data-id="element-247">
                  <span className="block text-[10px] font-bold text-white" style={{
                textShadow: 'rgba(0, 0, 0, 0.8) 0px 1px 3px'
              }} data-id="element-248">
                    {tome.label}
                  </span>
                  <span className="block text-[8px] sm:text-[9px] text-white/80 leading-tight mt-0.5" data-id="element-249">
                    {tome.desc}
                  </span>
                </div>
              </div>)}
          </div>

          {/* BADGE DEBAJO DE LOS TOMOS */}
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap bg-red-600 text-[10px] font-black text-white rounded-full px-3 py-1 shadow-sm" data-id="element-250">
            6 TOMOS COMPLETOS — SISTEMA MAESTRO
          </div>
        </div>

        {/* FEATURES */}
        <div className="mt-8 mx-auto max-w-2xl grid grid-cols-2 sm:grid-cols-3 gap-1.5" data-id="element-251">
          {features.map(feature => <span key={feature} className="bg-red-950/50 border border-red-900 rounded-full px-3 py-1 text-[11px] sm:text-xs font-semibold text-gray-300 text-center" data-id="element-252">
              {feature}
            </span>)}
        </div>

        {/* CTA */}
        <div className="mt-8" data-id="element-253"></div>
      </div>
    </section>;
}